import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../api.service';
import { ProfileRefreshService } from '../profile-refresh.service';

@Component({
  selector: 'app-apply-for-referral',
  templateUrl: './apply-for-referral.component.html',
  styleUrls: ['./apply-for-referral.component.css']
})
export class ApplyForReferralComponent implements OnInit {
  paymentId: any;
  paymentType: any = '';
  referralAvailable = false;
  userData: any;
  user_id: any;
  isLoading = false;
  saving = false;
  copied = false;

  constructor(private apiService: ApiService, private refresh: ProfileRefreshService) {}

  ngOnInit(): void {
    this.user_id = parseInt(localStorage.getItem('user_id'), 10);
    this.isLoading = true;
    this.loadUser();
  }

  private loadUser() {
    this.apiService.getUserById(this.user_id).subscribe(
      (response) => {
        this.userData = response;
        this.paymentId = response.Users.payment_id;
        this.paymentType = response.Users.payment_method || '';
        const code = response.Users.refer_code;
        this.referralAvailable = !(code === '' || code === null || code === undefined);
        this.isLoading = false;
        this.saving = false;
      },
      (error) => {
        console.log('error', error);
        this.isLoading = false;
        this.saving = false;
      }
    );
  }

  saveChanges() {
    this.saving = true;
    this.apiService.applyForReferral(this.user_id).subscribe(
      () => {
        alert('Applied for referral successfully');
        this.loadUser();
        this.refresh.ping();
      },
      (error) => {
        console.error('Error applying for referral', error);
        this.saving = false;
        alert('Could not apply for referral');
      }
    );
  }

  sendpaymentInfo() {
    this.saving = true;
    this.apiService.savePaymentInfo(this.user_id, this.paymentId, this.paymentType).subscribe(
      () => {
        this.saving = false;
        alert('Payment info saved');
      },
      () => {
        this.saving = false;
        alert('Error saving payment info');
      }
    );
  }

  copyCode() {
    const code = this.userData?.Users?.refer_code;
    if (!code) { return; }
    navigator.clipboard?.writeText(code).then(() => {
      this.copied = true;
      setTimeout(() => this.copied = false, 1500);
    });
  }
}
